/*
 * Tarkon — handlekurvskuffen
 * Design: design_handoff_handlekurv/
 *
 * Eneste oppgave: holde fraktstripa i synk når kurven endrer seg. Alt annet i
 * skuffen rendres på nytt av temaet ved hver kurvendring (cart.js bytter
 * innerHTML på #CartDrawerBody- og #CartDrawerFooter-), så det trenger ingen
 * klientlogikk.
 *
 * HVORFOR ET EGET ELEMENT OG IKKE TEMAETS free-shipping-goal
 * ----------------------------------------------------------
 * Temaet har allerede en FreeShippingGoal-klasse i assets/cart.js. Den mangler
 * to ting vi trenger: porten på 750, og den leser items_subtotal_price mens
 * summen vi viser er total_price. Med en aktiv rabattkode spriker de to, og
 * baren hopper ved første endring. cart.js er dessuten en temafil som kan bli
 * overskrevet ved en temaoppdatering, så logikken bor heller her.
 *
 * MÅLER MOT total_price, IKKE items_subtotal_price
 * ------------------------------------------------
 * Det er det samme tallet som står som «Sum» i footeren. Måler stripa mot noe
 * annet enn det kunden leser rett under, blir den umulig å stole på.
 */

class TarkonFraktstripe extends HTMLElement {
  connectedCallback() {
    this.grense = Number(this.dataset.grense) || 0;
    this.visFra = Number(this.dataset.visFra) || 0;
    this.gjenstarEl = this.querySelector('[data-tk-gjenstar]');
    this.barEl = this.querySelector('.tk-frakt__bar');

    this.onCartUpdate = this.onCartUpdate.bind(this);
    document.addEventListener('cart:updated', this.onCartUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener('cart:updated', this.onCartUpdate);
  }

  onCartUpdate(event) {
    const cart = event.detail && event.detail.cart;
    if (!cart) return;
    this.tegn(Number(cart.total_price) || 0);
  }

  /**
   * @param {number} sum handlekurvens total i øre
   */
  tegn(sum) {
    if (!this.grense) return;

    // Porten: under vis-fra er stripa borte helt, ikke bare tom.
    this.hidden = sum < this.visFra;

    const oppnadd = sum >= this.grense;
    this.classList.toggle('tk-frakt--oppnadd', oppnadd);

    const prosent = Math.min(100, Math.round((sum / this.grense) * 100));
    this.style.setProperty('--tk-frakt-fyll', `${prosent}%`);

    if (this.barEl) {
      this.barEl.setAttribute('aria-valuenow', Math.round(sum / 100));
    }

    // Beløpet som gjenstår trengs bare i den ene formen. Er den skjult, er det
    // heller ingen grunn til å formatere penger.
    if (!oppnadd && this.gjenstarEl) {
      this.gjenstarEl.textContent = this.formaterPenger(this.grense - sum);
    }
  }

  /**
   * Butikkens pengeformat er «{{amount_no_decimals}},-». Vi går gjennom temaets
   * egen formatterer når den finnes, så et framtidig formatbytte i Shopify slår
   * gjennom her også, og faller ellers tilbake på nb-NO uten desimaler.
   *
   * @param {number} ore
   * @returns {string}
   */
  formaterPenger(ore) {
    const tema = window.FoxTheme;
    if (tema && tema.Currency && tema.settings && tema.settings.moneyFormat) {
      return tema.Currency.formatMoney(ore, tema.settings.moneyFormat);
    }
    return `${new Intl.NumberFormat('nb-NO').format(Math.round(ore / 100))},-`;
  }
}

if (!customElements.get('tarkon-fraktstripe')) {
  customElements.define('tarkon-fraktstripe', TarkonFraktstripe);
}
